import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define state type
export type FeedbackModalState = boolean;

const initialState: FeedbackModalState = false;

export const feedbackModalSlice = createSlice({
  name: 'feedbackModal',
  initialState,
  reducers: {
    showModal: (state, action: PayloadAction<boolean>) => {
      return action.payload;
    }
  }
});

export const { showModal } = feedbackModalSlice.actions;
export default feedbackModalSlice.reducer;
